import { useParams } from "react-router-dom";
import WebsiteLibrary from "./WebsiteLibrary";
import { websiteProjects } from "./projects";

export const libraryBrand = {
  theme: "light" as const,
  basePath: "/websites",
  inquiryHref: "/templates#contact",
  brandHref: "/",
  logoSrc: "https://cmj-site.nyc3.digitaloceanspaces.com/CMJS-IOS-2.png",
};

export default function WebsiteLibraryPage() {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  return <WebsiteLibrary {...libraryBrand} projects={websiteProjects} projectSlug={projectSlug} />;
}
